import { get } from 'lodash';
import { request, RequestInitWithRetry } from '../../lib/request';
import { ISortResult } from '../shared/common';

export interface IPerformanceUtilizationDeviceRow {
  id: string,
  used: number,
  serialNumber: string,
  assetTag: string,
  imei: string,
  deviceName: string,
  manufacturer: string,
  model: string,
  group: string[],
  homeLocation: { name: string } | null,
  firmware?: { version: string },
  operatingSystem?: { buildVersion: string },
  bios?: { version: string },
  updated: string
}

export interface IPerformanceUtilizationDevicesListData {
  list: IPerformanceUtilizationDeviceRow[],
  totalCount: number
}

export interface IPerformanceUtilizationDevicesFilter {
  manufacturers?: string[],
  models?: string[],
  homeLocations?: Array<string | null>,
  groups?: Array<string | null>,
  manufacturers_negate?: boolean,
  models_negate?: boolean,
  homeLocations_negate?: boolean,
  groups_negate?: boolean
}

export interface IPerformanceUtilizationDevicesOptions {
  utc: number,
  timeZone: string,
  zoneId?: string | null,
  limit: number,
  offset: number,
  sort?: ISortResult,
  filter?: IPerformanceUtilizationDevicesFilter
}

const getFilterParams = (filter: IPerformanceUtilizationDevicesFilter = {}) => {
  return {
    manufacturers: filter.manufacturers || [],
    models: filter.models || [],
    homeLocations: filter.homeLocations || [],
    groups: filter.groups || [],
    ...(filter.manufacturers_negate && { manufacturers_negate: true }),
    ...(filter.models_negate && { models_negate: true }),
    ...(filter.homeLocations_negate && { homeLocations_negate: true }),
    ...(filter.groups_negate && { groups_negate: true })
  };
};

export function getCorePerformanceUtilizationDevicesList(params: IPerformanceUtilizationDevicesOptions) {
  return async (options: RequestInitWithRetry): Promise<IPerformanceUtilizationDevicesListData> => {
    const input = {
      path: '/api/core/performance/devicesUtilization/list',
      qs: { limit: params.limit, offset: params.offset },
      body: {
        utc: params.utc,
        timeZone: params.timeZone,
        zoneId: params.zoneId,
        sort: get(params, 'sort'),
        filter: getFilterParams(params.filter)
      },
      method: 'post'
    };
    return request(input, options);
  };
}

export function exportCorePerformanceUtilizationDevicesListAction(requestOptions: RequestInitWithRetry) {
  return async (params: IPerformanceUtilizationDevicesOptions): Promise<string> => {
    const input = {
      path: '/api/core/performance/devicesUtilization/export',
      qs: { limit: params.limit, offset: params.offset },
      body: {
        utc: params.utc,
        timeZone: params.timeZone,
        zoneId: params.zoneId,
        sort: get(params, 'sort'),
        filter: getFilterParams(params.filter)
      },
      method: 'post'
    };
    return request(input, requestOptions);
  };
}
